import { IconProps } from './types';

export function Moon({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 15 16" {...props}>
      <path
        fill="currentColor"
        d="M7.806 15.147c-.113 0-.226 0-.34-.007C3.733 14.974.613 11.967.353 8.3.126 5.155 1.946 2.215 4.88.98c.833-.346 1.273-.08 1.46.114.186.187.446.62.1 1.413a5.464 5.464 0 0 0-.454 2.234c.014 2.953 2.467 5.46 5.46 5.58.434.02.86-.014 1.274-.087.88-.16 1.246.193 1.386.42.14.226.3.713-.233 1.433a7.488 7.488 0 0 1-6.067 3.06Zm-6.46-6.92c.227 3.173 2.934 5.774 6.16 5.913a6.487 6.487 0 0 0 5.554-2.64c.1-.14.146-.24.166-.293a1.049 1.049 0 0 0-.333.02c-.487.087-.993.12-1.493.1-3.52-.14-6.4-3.093-6.42-6.573 0-.92.18-1.807.546-2.64a.964.964 0 0 0 .087-.3.89.89 0 0 0-.34.087C2.733 2.967 1.16 5.514 1.346 8.227Z"
      />
    </svg>
  );
}
